export default function PartnerHeroSection() {
  return (
    <section
      className="relative flex items-center justify-center overflow-hidden"
      style={{ paddingTop: '72px', minHeight: '460px' }}
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/partner1.jpg"
          alt="パートナー探し - 丁寧なカウンセリングの様子"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0" style={{ background: 'rgba(74,55,40,0.55)' }} />
      </div>
      <div className="relative z-10 w-full content-width text-center py-20">
        <div className="animate-fadeIn">
          <p
            className="inline-block px-4 py-1 rounded-full mb-5 text-sm font-bold"
            style={{ background: 'rgba(255,255,255,0.2)', color: '#f5d9b8', border: '1px solid rgba(255,255,255,0.4)' }}
          >
            パートナー探し
          </p>
          <h1 className="text-white mb-6" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.4)' }}>
            しっかりパートナーを探したい方へ
          </h1>
          <p className="text-white/90 mx-auto max-w-2xl" style={{ fontSize: '18px' }}>
            結婚・再婚をお考えの方を、経験豊富なカウンセラーが丁寧にサポートします。
            <br className="hidden sm:block" />
            あなたのペースで、確かなご縁を見つけてください。
          </p>
        </div>
      </div>
    </section>
  );
}
